import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { useEffect } from "react";
import { COMPANY } from "../data/site";

/**
 * Mobile-only sticky CTA bar with Ring + Få offert.
 */
export default function MobileCTA() {
  useEffect(() => {
    document.body.classList.add("has-mobile-cta");
    return () => document.body.classList.remove("has-mobile-cta");
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-30 grid grid-cols-2 gap-2 p-3 bg-white border-t border-[#E2E0D8] shadow-[0_-6px_18px_-8px_rgba(0,0,0,0.18)]"
      role="region"
      aria-label="Snabbkontakt"
    >
      <a
        href={`tel:${COMPANY.phoneE164}`}
        data-testid="mobile-cta-call"
        className="inline-flex items-center justify-center gap-2 bg-[#1B2A1E] text-white font-semibold py-3 rounded-lg hover:bg-[#283224] transition-colors"
      >
        <Phone className="w-4 h-4" /> Ring
      </a>
      <Link
        to="/kontakt#offert"
        data-testid="mobile-cta-quote"
        className="inline-flex items-center justify-center gap-2 bg-[#D95D2E] text-white font-semibold py-3 rounded-lg hover:bg-[#B84B22] transition-colors"
      >
        <FileText className="w-4 h-4" /> Få offert
      </Link>
    </div>
  );
}
